import { OMPMakerEventConstantS } from '../Constant/module/OMPMakerEventConstantS.js';
export const findEventByName = (event_name) => {
  return OMPMakerEventConstantS.EVENTS.find((info) => info.event_name === event_name);
};
